import { render, staticRenderFns } from "./StepsHeaderRecomend.vue?vue&type=template&id=95f7b20e&scoped=true"
import script from "./StepsHeaderRecomend.vue?vue&type=script&lang=js"
export * from "./StepsHeaderRecomend.vue?vue&type=script&lang=js"
import style0 from "./StepsHeaderRecomend.vue?vue&type=style&index=0&id=95f7b20e&prod&scoped=true&lang=scss"
import style1 from "./StepsHeaderRecomend.vue?vue&type=style&index=1&id=95f7b20e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f7b20e",
  null
  
)

export default component.exports